module.exports = __webpack_public_path__ + "img/cb13.131a43be.png";